<template>
  <div class="info-form">
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="name" class="label">姓名:</label>
        <input type="text" id="name" placeholder="必填" v-model="formData.name" required class="form-input">
      </div>
      <div class="form-group">
        <p class="error-msg">{{errormsg}}</p>
        <label for="examNumber" class="label">高考报名号:</label>
        <input type="text" id="examNumber" placeholder="必填" v-model="formData.candidateNumber" required class="form-input">
      </div>
      <div class="form-group">
        <label for="idCard" class="label">身份证:</label>
        <input type="text" id="idCard" v-model="formData.idNumber" class="form-input">
      </div>
      <div class="form-group">
        <label for="highSchool" class="label">毕业高中:</label>
        <input type="text" id="highSchool" v-model="formData.school" class="form-input">
      </div>
      <div class="form-group">
        <label for="phone" class="label">手机号:</label>
        <input type="tel" id="phone" v-model="formData.phone" class="form-input">
      </div>
      <div class="form-group">
        <label for="grade" class="label">分数:</label>
        <input type="tel" id="grade" v-model="formData.grade" class="form-input">
      </div>
      <div class="button-group">
        <button type="submit" class="submit-button">提交</button>
        <button type="button" @click="cancelForm" class="cancel-button">取消</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      formData: {
        name: '',
        candidateNumber: '',
        idNumber: '',
        school: '',
        phone: '',
        grade: ''
      },
      username: JSON.parse(localStorage.getItem("username")),
      errormsg: ''
    };
  },
  methods: {
    submitForm() {
      console.log('提交的信息:', this.formData);
      axios.post('http://39.100.109.86:8093/student', {
        name: this.formData.name,
        candidateNumber: this.formData.candidateNumber,
        idNumber: this.formData.idNumber,
        school: this.formData.school,
        phone: this.formData.phone,
        grade: this.formData.grade,
        username: this.username
      })
          .then(response => {
            // 处理响应数据
            console.log(response.data.msg);
            if (response.data.msg === null) {
              this.$router.push({ name: 'Show' });
            } else {
              this.errormsg = '报名号重复';
            }
          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });
    },
    cancelForm() {
      // 导航回Show.vue页面
      this.$router.push({ name: 'Show' });
    }
  }
};
</script>

<style scoped>
.info-form {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-width: 400px;
  margin: 0 auto;
  background-color: white;
}

.form-group {
  margin-bottom: 1rem;
}

.label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: 700;
  font-size: 16px;
  text-align: left;
}

.form-input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 15px;
  outline: none;
  transition: border-color 0.3s ease;
}

.form-input:focus {
  border-color: #0E7AC3;
}

.button-group {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.submit-button, .cancel-button {
  width: 48%;
  padding: 10px 0;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-button {
  background-color: #0E7AC3;
  color: white;
}

.submit-button:hover {
  background-color: #0e6ca3;
}

.cancel-button {
  background-color: #f5f5f5;
  color: #333;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.error-msg {
  color: crimson;
  text-align: center;
  margin-bottom: 1rem;
  font-size: 14px;
}
</style>
